export const isSameAudioObject = (left: string, right: string): boolean =>
  left.split('?')[0] === right.split('?')[0];
